import axios from 'axios'
import React from 'react'
import { useState } from 'react'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useParams } from 'react-router-dom'
import Swal from 'sweetalert2'
import { getSingleAirConditioning, updateAirConditioning  } from '../../actions/homeAction'

const CarConditioningUpdate = () => {

    const [carConditioning, setCarConditioning] = useState({
        // carDealerName:'',
        // mobileNumber:'',
        // mobileNumberCountryCode: '',
        // location: '',
        // about:'',
        // category:'',
        status: '',
        subscriptionExpiry: '',
    })
    const { cCUpdate } = useParams()

    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(getSingleAirConditioning(cCUpdate))
    },[])

    const data = useSelector(state => state.home.singleAirCondition)

    console.log("data", data);
    
    const carConditioningData =  data?.[0]

    console.log("carConditioningData", carConditioningData, cCUpdate);
    useEffect(() => {
        setCarConditioning({
            // carDealerName: carDealerData?.carDealerName,
            // mobileNumber: carDealerData?.mobileNumber,
            // location: carDealerData?.location,
            // mobileNumberCountryCode: carDealerData?.mobileNumberCountryCode,
            // about: carDealerData?.about,
            status: carConditioningData?.status,
            subscriptionExpiry: carConditioningData?.currentSubscription?.expiry?.split('T')[0] || '',
        })
    },[carConditioningData])
    
    const config = {
        headers: {
            'Content-Type': 'application/json',
            Authorization: localStorage.getItem('loged_In_auth'),
        },
    };

    const onChangeHandle = (e) => {
        const {name, value} = e.target
        setCarConditioning({...carConditioning, [name]:value})
    }
    console.log("update", carConditioning);
    const onEdit = () => {
        if (carConditioningData !== null) {
            const updatedData = {
                businessId: cCUpdate,
                status: carConditioning?.status,
            };
    
            if (carConditioning.subscriptionExpiry) {
                try {
                    updatedData.subscriptionExpiry = new Date(carConditioning.subscriptionExpiry).toISOString();
                } catch (e) {
                    console.error("Invalid subscriptionExpiry:", carConditioning.subscriptionExpiry);
                }
            }
    
            dispatch(updateAirConditioning(updatedData));
        }
    };
    

    const [image, setImage] = useState({})

    const uploadMedia = (e) => {
        // console.log("imageData", e.target.files[0]);
        const file = e.target.files[0]

        const reader = new FileReader(file)
        reader.readAsDataURL(file)

        if(file !== undefined){
            reader.onloadend = () => {
                setImage({
                    image: reader.result
                })
            }
        }
        const data = new FormData();

        data.append('media', file)
        axios.post('https://caravenue.infoware.xyz/api/media/new', data, config)
            .then(res => {
                Swal.fire({
                    title: 'Upload Successfully',
                    icon: 'success',
                    imageUrl: './assets/images/favicon/android-chrome-192x192.png',
                    imageHeight: 100,
                    text: '',
                    type: 'success',
                    confirmButtonColor: '#3ab1f7',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Ok',
                })
                setImage({ logo: res.data.response.media[0].mediaId})
            })
            .catch(err => {
                Swal.fire({
                    title:
                        err.response !== undefined
                            ? err.response.data.response.message
                            : 'something went wrong Upload again!!!',
                    icon: 'error',
                    imageUrl: './assets/images/favicon/android-chrome-192x192.png',
                    imageHeight: 100,
                    text: '',
                    type: 'success',
                    confirmButtonColor: '#3ab1f7',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Ok',
                })
            })
    }
    
  return (
    <div className='main-body'>
                <div className='page-wrapper'>
                    <div className='page-header'>
                        <div className='row align-items-end'>
                            <div className='col-lg-8'>
                                <div className='page-header-title'>
                                    <div className='d-inline'>
                                        <h4>
                                            Edit : {carConditioningData?.airConditioningName}
                                        </h4>
                                    </div>
                                </div>
                            </div>
                            <div className='col-lg-4'>
                                <div className='page-header-breadcrumb'>
                                    <ul className='breadcrumb-title'>
                                        <li className='breadcrumb-item'>
                                            <Link to='/'>
                                                <i className='feather icon-home'></i>{' '}
                                            </Link>
                                        </li>
                                        <li className='breadcrumb-item'>
                                            <Link to='/ServiceProviders/CarConditioning'>Car Conditioning List</Link>
                                        </li>
                                        <li className='breadcrumb-item active'>
                                            Edit Car Conditioning
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='page-body'>
                        <div className='row'>
                            <div className='col-sm-12'>
                                <div className='card card-border-default'>
                                    <div className='card-block'>
                                        <div className='tab-content tabs'>
                                            <div
                                                className='tab-pane  active'
                                                id={'car_user_'}
                                                role='tabpanel'
                                                aria-labelledby=''>
                                                    <div className=''>
                                                        <div className='card-body'>
                                                            <div className='row'>
                                                                {/* <div className='col-md-6'>
                                                                    <div className='form-group row'>
                                                                        <label className='col-sm-3 col-form-label'>Car Dealer Name</label>
                                                                        <div className='col-sm-9'>
                                                                            <input
                                                                                type='text'
                                                                                className='form-control'
                                                                                name='carDealerName'
                                                                                value={carDealer.carDealerName}
                                                                                placeholder='Car Dealer Name'
                                                                                onChange={onChangeHandle}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div> */}
                                                                {/* <div className='col-md-6'>
                                                                    <div className='form-group row'>
                                                                        <label className='col-sm-3 col-form-label'>Country Code</label>
                                                                        <div className='col-sm-9'>
                                                                            <select name="mobileNumberCountryCode" className='form-control' value={carDealer.mobileNumberCountryCode} onChange={onChangeHandle}>
                                                                                <option value="">Select County Code</option>
                                                                                <option value="+965">+965</option>
                                                                            </select>
                                                                        </div>
                                                                    </div>
                                                                </div> */}
                                                                {/* <div className='col-md-6'>
                                                                    <div className='form-group row'>
                                                                        <label className='col-sm-3 col-form-label'>Phone Number</label>
                                                                        <div className='col-sm-9'>
                                                                            <input
                                                                                type='number'
                                                                                className='form-control'
                                                                                name='mobileNumber'
                                                                                value={carDealer.mobileNumber}
                                                                                placeholder='Phone Number'
                                                                                onChange={onChangeHandle}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div> */}
                                                                {/* <div className='col-md-6'>
                                                                    <div className='form-group row'>
                                                                        <label className='col-sm-3 col-form-label'>Location</label>
                                                                        <div className='col-sm-9'>
                                                                            <input
                                                                                type='text'
                                                                                className='form-control'
                                                                                name='location'
                                                                                value={carDealer.location}
                                                                                placeholder='Enter Location'
                                                                                onChange={onChangeHandle}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div> */}
                                                                {/* <div className='col-md-6'>
                                                                    <div className='form-group row'>
                                                                        <label className='col-sm-3 col-form-label'>Brand</label>
                                                                        <div className='col-sm-9'>
                                                                            <input
                                                                                type='text'
                                                                                className='form-control'
                                                                                name='about'
                                                                                value={carDealer.about}
                                                                                placeholder='Brand Name'
                                                                                onChange={onChangeHandle}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div> */}
                                                                {/* <div className='col-md-6'>
                            <div className='row'>
                                <div className='col-sm-3'> Image</div>
                                <div className='col-sm-9'>
                                    <form
                                        id='userImage'
                                        name='userImage'
                                        encType='multipart/form-data'
                                        className='text-capitalize'>
                                        <div className='form-group'>
                                            <input
                                                accept='image/*'
                                                onChange={uploadMedia}
                                                id='banner_image'
                                                type='file'
                                                className='form-control'
                                                autoComplete='off'
                                                name='media'
                                                data-toggle='tooltip'
                                                title='Click To Upload Photo'
                                            />
                                            <div id='banner_image_lable' className='pt-2'>
                                                    <img
                                                        src={}
                                                        alt=''
                                                        className='img-100'
                                                        onError={e => {
                                                            e.target.src = '';
                                                        }}
                                                    />

                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div> */}
                         <div className='col-md-6'>
                                                                <div className='form-group row'>
                                                                    <label className='col-sm-3 col-form-label'>Status</label>
                                                                    <div className='col-sm-9'>
                                                                    <select
                                                                        className='form-control'
                                                                        name='status'
                                                                        value={carConditioning.status}
                                                                        disabled={carConditioning.status === 'delete'}
                                                                        onChange={onChangeHandle}
                                                                    >
                                                                        <option value='active'>Active</option>
                                                                        <option value='in-active'>Inactive</option>
                                                                    </select>
                                                                    </div>
                                                                </div>
                                                                </div>
                                                                <div className='col-md-6'>
                                                                <div className='form-group row'>
                                                                    <label className='col-sm-3 col-form-label'>Membership Expiry</label>
                                                                    <div className='col-sm-9'>
                                                                    <input
                                                                        type='date'
                                                                        className='form-control'
                                                                        name='subscriptionExpiry'
                                                                        value={carConditioning.subscriptionExpiry}
                                                                        disabled={!carConditioning.subscriptionExpiry}
                                                                        onChange={onChangeHandle}
                                                                    />
                                                                    </div>
                                                                </div>
                                                                </div>
                                                            </div>
                                                            <div className='card-footer'>
                                                                <div className='row float-right p-3'>
                                                                    
                                                                    <button
                                                                        onClick={onEdit}
                                                                        className='btn btn-grd-disabled mr-2'>
                                                                        <i className='icofont icofont-save'></i> Update
                                                                    </button>
                                                                    <Link to={'/ServiceProviders/CarConditioning'} className='btn btn-outline-dark'>
                                                                        Cancel
                                                                    </Link>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    
  )
}

export default CarConditioningUpdate